//
// js-boggle-line-chart.js - a line chart
//

import * as bogglechart from 'bogglechart';


const small_layouts = [
  'column_width',
  'regular',
];


export default function js_boggle_line_chart(div) {
  const canvas = bogglechart.create_canvas(div);
  canvas.classList.add('absolute--fill');

  const x_label     = div.bogglechart_labels;
  const lines_data  = div.bogglechart_data;

  const is_small = small_layouts.includes(div.bogglechart_opts.width);
  const fontsize__label     = is_small ? 0.039 : 0.03;
  const fontsize__axis_name = is_small ? 0.042 : 0.033;

  const design_props = {
    default_font:         'Roboto',
    x_axis_width:         g => g.h * 0.006,

    labels_x_fontsize:    g => g.h / g.pr * fontsize__label,
    labels_x_padding:     g => g.h * 0.021,

    y_axis_name_fontsize: g => g.h / g.pr * fontsize__axis_name,

    labels_y_fontsize:    g => g.h / g.pr * fontsize__label,
    labels_y_padding:     g => g.h * 0.021,
    legend_fontsize:      g => g.h / g.pr * fontsize__axis_name,
  };

  const graph_props = {...div.bogglechart_opts, ...design_props};

  const line_chart = bogglechart.line_chart(
    canvas,
    lines_data,
    graph_props,
    typeof x_label === 'string' ? i => `${x_label} ${i}` : x_label
  );
  line_chart.draw();
}

